import React from 'react';
import { connect } from 'react-redux';
// Level popup imports
import LevelPopupLayout from '../layout';
import ButtonsContainer from '../buttonsContainer';

class LevelPopupFinish extends React.Component {
    render = () => {
        const { gameInfo } = this.props;

        return (
            <LevelPopupLayout id="level-finish-popup" imgSrc="gehaald.png" imgAlt="Prijsbeker met sterren" title="YEAH GELUKT">
                <div className="level-description">
                    <span className="desc">Game uitgespeeld!</span>
                    <span className="points-scored">{gameInfo.score}</span>
                </div>
                <div className="padding" />
                <ButtonsContainer />
            </LevelPopupLayout>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    gameInfo: state.gameInfo
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelPopupFinish);
